/* eslint-disable no-underscore-dangle */
import { makeObservable } from 'mobx';
import { isPast, isToday, isUpcoming, isWithinHours } from '@helpers/dateUtils';
import { TeamGameResponse } from '@dto/api';

interface Schedule {
  upcoming: TeamGameResponse[];
  past: TeamGameResponse[];
  today: TeamGameResponse[];
}

class TeamStore {
  schedule: Schedule = {
    upcoming: [],
    past: [],
    today: [],
  };

  constructor() {
    //makeAutoObservable(this, {}, { autoBind: true });
    makeObservable(this, {
      schedule: false,
      setSchedule: false,
      fetchSchedule: true,
    });
    this.setSchedule({
      upcoming: [],
      past: [],
      today: [],
    });
  }

  setSchedule(schedule: Schedule) {
    this.schedule = schedule;
  }

  resetSchedule() {
    this.schedule = {
      upcoming: [],
      past: [],
      today: [],
    };
  }

  fetchSchedule() {
    return {
      past: this.schedule.past.sort(
        (a: TeamGameResponse, b: TeamGameResponse) =>
          new Date(a.scheduleTsStart).getTime() -
          new Date(b.scheduleTsStart).getTime()
      ),
      upcoming: this.schedule.upcoming.sort(
        (a: TeamGameResponse, b: TeamGameResponse) =>
          new Date(a.scheduleTsStart).getTime() -
          new Date(b.scheduleTsStart).getTime()
      ),
      today: this.schedule.today.sort(
        (a: TeamGameResponse, b: TeamGameResponse) =>
          new Date(a.scheduleTsStart).getTime() -
          new Date(b.scheduleTsStart).getTime()
      ),
    };
  }
  // add a game to the schedule
  updateSchedule(teamGame: TeamGameResponse) {
    let updateToday = this.schedule.today;
    let updateUpcoming = this.schedule.upcoming;
    let updatePast = this.schedule.past;
    if (isToday(teamGame.scheduleTsStart)) {
      updateToday = [...updateToday, teamGame];
    } else if (isPast(teamGame.scheduleTsStart)) {
      updatePast = [...updatePast, teamGame];
    } else {
      updateUpcoming = [...updateUpcoming, teamGame];
    }
    this.schedule = {
      past: updatePast,
      upcoming: updateUpcoming,
      today: updateToday,
    };
  }
  // updates an existing game in the schedule
  updateGame(teamGame: TeamGameResponse) {
    let updateToday = this.schedule.today;
    let updateUpcoming = this.schedule.upcoming;
    let updatePast = this.schedule.past;
    let fullList = [...updateToday, ...updateUpcoming, ...updatePast];

    fullList = fullList.map((game) => {
      return game.id === teamGame.id ? teamGame : game;
    });

    updatePast = fullList.filter((x: TeamGameResponse) =>
      isPast(x.scheduleTsStart)
    );

    updateUpcoming = fullList.filter((x: TeamGameResponse) =>
      isUpcoming(x.scheduleTsStart)
    );

    updateToday = fullList.filter((x: TeamGameResponse) =>
      isToday(x.scheduleTsStart)
    );

    this.schedule = {
      past: updatePast,
      upcoming: updateUpcoming,
      today: updateToday,
    };
  }

  deleteGame(teamGameId: string) {
    let updateUpcoming = this.schedule.upcoming;
    let updateToday = this.schedule.today;
    let updatePast = this.schedule.past;
    const fullList = [...updateToday, ...updateUpcoming, ...updatePast];
    const updatedFull = fullList.filter((game) => game.id !== teamGameId);

    updatePast = updatedFull.filter((x: TeamGameResponse) =>
      isPast(x.scheduleTsStart)
    );

    updateUpcoming = updatedFull.filter((x: TeamGameResponse) =>
      isUpcoming(x.scheduleTsStart)
    );

    updateToday = updatedFull.filter((x: TeamGameResponse) =>
      isToday(x.scheduleTsStart)
    );

    this.schedule = {
      past: [...updatePast],
      upcoming: [...updateUpcoming],
      today: [...updateToday],
    };
  }

  nextStreamableGame() {
    const updateUpcoming = this.schedule.upcoming;
    const updateToday = this.schedule.today;
    const updatePast = this.schedule.past;
    const fullList = [...updateToday, ...updateUpcoming, ...updatePast];
    const canGoLive = fullList
      .filter(
        (x: TeamGameResponse) => isWithinHours(x.scheduleTsStart) && !x.isEnded
      )
      .sort((a, b) => a.scheduleTsStart - b.scheduleTsStart);
    return canGoLive[0];
  }
}

export default TeamStore;
